import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import * as d3 from "d3";
import c3 from "c3";
import "d3-scale";

"use strict";
var default_colors = d3.schemeSet3;
function redefine_chart_spec(chart_info, dimfield, dimpivot, series) {
    var columns = [];
    var types = {};
    var names = {};
    var groups = [];
    var cgroup = [];
    var axes = { "y":[], "y2":[] };
    //pie/donut chart support only 1 series.
    var serie = series[0];

    var chart_spec = {
        data:{
            "type":serie.seriestype || "pie",
            "columns":[]
        },
        pie: {
            label: {
                format:function(value, ratio, id) {
                    return ""+(d3.format(".1%")(ratio))+" ("+ value+")";
                }
            }
        },
        donut: {
            label: {
                format:function(value, ratio, id) {
                    return ""+(d3.format(".1%")(ratio))+" ("+ value+")";
                }
            }
        },
        transition: {
            duration: 0
        },
        tooltip: {
            format: {
                value: function(value, ratio, id) {
                    return ""+(d3.format(".1%")(ratio))+" ("+ value+")";
                }
            }
        }
    };
    chart_spec.data.color = function(col, d) {
        if (d.id && d.index !== undefined) {
            return default_colors(d.index);
        }
        return col;
    };
    return chart_spec;
}


var pie_chart_creator = {
    init:function create_pie_chart(chart_info, dimfield, dimpivot, series, click_callback) {
        var charts = [];
        var raw_data = ko.observable(null);
        var data_hashes = ko.observable({});
        var chart_spec = null;
        var drawing = false;
        var pie_chart = {
            initialisation_func: function(selector) {
                chart_spec = redefine_chart_spec(chart_info, dimfield, dimpivot, series);
                $(selector).on("resize", function(ev, ui) {
                    pie_chart.resize_charts(selector);
                });
            },
            resize_charts: function(selector) {
                if (drawing) return;
                drawing = true;
                try {
                    var $sel = $(selector);
                    var full_width = $sel.width();
                    var full_height = $sel.height();

                    var row_size = full_width > 1000
                            ? charts.length >= 4 ? 4 : charts.length
                            : full_width > 600
                                ? charts.length >= 2 ? 2 : charts.length
                                : 1;
                    var chart_width = (full_width / row_size) - (row_size > 1 ? 5 : 0);
                    chart_width = Math.floor(chart_width);

                    var height = Math.round(chart_width / 1.618 + 100);

                    //viewport height
                    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                    if (height >= h/2)
                        height = h/2;

                    d3.select(selector).selectAll("div.pie_chart").style("width", chart_width+"px").each(function(d) {
                        $(this).children(".c3_container").css("height", height+"px");
                        $(this).data().c3_chart.resize();
                    });
                }
                finally {
                    drawing = false;
                }
            },
            update_data: function(data) {
                raw_data(data);
                var hashes = {};
                data_hashes(hashes);
                data = pie_chart.massage_data(data, hashes);
                return [data, hashes];
            },
            render: function(data, selector) {
                var full_width = $(selector).width();
                var full_height = $(selector).height();

                var row_size = full_width > 1000
                        ? charts.length >= 4 ? 4 : charts.length
                        : full_width > 600
                            ? charts.length >= 2 ? 2 : charts.length
                            : 1;
                if (row_size <= 0) row_size = 1;
                var chart_width = (full_width / row_size) - (row_size > 1 ? 5 : 0);
                chart_width = Math.floor(chart_width);

                var height = Math.round(chart_width / 1.618 + 100);

                //viewport height
                var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                if (height >= h/2)
                    height = h/2;

                var main_selection = d3.select(selector).selectAll("div.pie_chart").data(data);//, key=function(d) { return d.title; });
                main_selection.exit && main_selection.exit().each(function(d,i) {
                    var chart = $(this).data("c3_chart");
                    charts.splice(charts.indexOf(chart), 1);
                }).remove(); //delete dead charts

                main_selection.enter()
                    .append("div")
                    .attr("class", "pie_chart")
                    .style("width", chart_width+"px")
                    .each(function(d, i) {
                        if (d.title || data.length > 1) {
                            if (d.title && d.title != "")
                                $("<header></header>").addClass("chart-header").appendTo($(this)).text(d.title);
                            else
                                $("<header></header>").addClass("chart-header").appendTo($(this)).html("&nbsp;");
                        }
                        var $new_div = $("<div></div>").appendTo($(this)).attr("class", "c3_container").css("height", height+"px");
                        var $chart = $(this);
                        var new_spec = $.extend({chart_index:charts.length}, chart_spec, {bindto : $new_div[0]});
                        new_spec.data.onclick = function(datapoint, elt) {
                            var chart_index = new_spec.chart_index;
                            var hashes = data_hashes();
                            if (datapoint) {
                                var raw_index = hashes[chart_index + "_" + datapoint.index];
                                var datum = raw_data()[raw_index];
                                if (datum && click_callback) {
                                    click_callback({ "point":datum });
                                }
                            }
                        };
                        var c = c3.generate(new_spec);
                        $chart.data("c3_chart", c);
                        charts.push(c);
                    }).each(function(d,i) {
                        var $chart = $(this);
                        $chart.children(".c3_container").css("height", height+"px");
                        var chart = $chart.data("c3_chart");
                        chart.load(d);
                    });

                main_selection.style("width", chart_width+"px").each(function(d,i) {
                    var $chart = $(this);
                    $chart.children(".c3_container").css("height", height+"px");
                    var chart = $chart.data("c3_chart");
                    chart.load(d);
                });

            },
            update_data_func: function(selector, data) {
                drawing = true;
                try {
                    var data = this.update_data(data)[0];
                    this.render(data, selector);
                }
                finally {
                    drawing = false;
                }
            },
            massage_data: function(data, data_hashes) {
                var datum = null;
                var chart_data = [];
                var x_values = ["x"];
                var caption = chart_info.map[dimfield];
                var pivotfield = dimpivot ? chart_info.map[dimpivot] : null;
                var groups = {
                };
                var serie = series[0];
                var valuefield = chart_info.map[serie.value];
                $.each(data, function(idx, val) {
                    var pivot_val = pivotfield ? val[pivotfield] : "";
                    var datum = groups[pivot_val];
                    if (!datum) {
                        datum = groups[pivot_val] = { "columns":[] };
                        datum.title = (pivotfield ? pivot_val : null) || chart_info.caption_no_pivot;
                        datum.index = chart_data.length;
                        chart_data.push(datum);
                    }
                    data_hashes[datum.index + "_" + (datum.columns.length)] = idx;
                    datum.columns.push([val[caption] || chart_info.caption_no_dimension ||  "-", val[valuefield] || 0]);
                });
                return chart_data;
            },
        };
        return pie_chart;
    }
};

export default pie_chart_creator;
